import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";

export default function LoanInquiry() {
  const [loanForm, setLoanForm] = useState({
    name: "",
    email: "",
    phone: "",
    loanType: "",
    amount: "",
    purpose: "",
  });
  const [submitStatus, setSubmitStatus] = useState("");
  // Deployment ID
  // AKfycbyqbtv4CV-bCjoKlHnt2sJpTiEvFHnntUkCGcC88nxJzxnyO62uMNqZV6UwCfJpR8Ns
  // URL
  // https://script.google.com/macros/s/AKfycbyqbtv4CV-bCjoKlHnt2sJpTiEvFHnntUkCGcC88nxJzxnyO62uMNqZV6UwCfJpR8Ns/exec
  // const handleLoanSubmit = async (e) => {
  //   e.preventDefault();
  //   setSubmitStatus("sending");

  //   setTimeout(() => {
  //     setSubmitStatus("success");
  //     setLoanForm({
  //       name: "",
  //       email: "",
  //       phone: "",
  //       loanType: "",
  //       amount: "",
  //       purpose: "",
  //     });
  //     setTimeout(() => setSubmitStatus(""), 3000);
  //   }, 1000);
  // };

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     const url = 'https://script.google.com/macros/s/AKfycbyqbtv4CV-bCjoKlHnt2sJpTiEvFHnntUkCGcC88nxJzxnyO62uMNqZV6UwCfJpR8Ns/exec';

  //     fetch(url, {
  //       method: 'POST',
  // headers: {
  //         'Content-Type': 'application/x-www-form-urlecoded',
  //       },
  //       body: (`name=${e.target.name.value}
  //               &emali=${e.target.email.value}
  //               &phone=${e.target.phone.value}
  //               &loanType=${e.target.loanType.value}
  //               &amount=${e.target.amount.value}
  //               &purpose=${e.target.purpose.value}
  // `)
  //     })
  //     .then((res) => res.text()).then(data=>{
  //       alert(data)
  //     }).catch(error=>console.log(error));
  //   };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitStatus("sending");

    const url =
      "https://script.google.com/macros/s/AKfycbxssMxQuXpXPFb0ML3rBuT0J0CB9IudM0RoIshlpLjFv2itbYZFiaQpIoYKZiOLg6Ya/exec";

    const formData = new URLSearchParams();
    formData.append("name", loanForm.name);
    formData.append("email", loanForm.email);
    formData.append("phone", loanForm.phone);
    formData.append("loanType", loanForm.loanType);
    formData.append("amount", loanForm.amount);
    formData.append("purpose", loanForm.purpose);

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    })
      .then((res) => {
        // Handle both success and error responses
        if (res.ok || res.status === 200) {
          return res.text();
        }
        throw new Error("Network response was not ok");
      })
      .then((data) => {
        // Success - form submitted
        setSubmitStatus("success");
        // Clear React state for mobile compatibility
        setLoanForm({
          name: "",
          email: "",
          phone: "",
          loanType: "",
          amount: "",
          purpose: "",
        });
        // Also clear HTML form
        e.target.reset();
        setTimeout(() => setSubmitStatus(""), 3000);
      })
      .catch((err) => {
        // Even if there's a "network error", the form might have submitted successfully
        // Google Apps Script sometimes returns CORS errors even on success
        console.log("Submission completed (possible CORS response):", err);
        setSubmitStatus("success");
        // Clear form anyway since submission likely worked
        setLoanForm({
          name: "",
          email: "",
          phone: "",
          loanType: "",
          amount: "",
          purpose: "",
        });
        e.target.reset();
        setTimeout(() => setSubmitStatus(""), 3000);
      });
  };

  return (
    <Box
      component="section"
      id="loan-inquiry"
      sx={{ py: { xs: 10, md: 12 }, bgcolor: "grey.50" }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Chip
              label="Loan Services"
              sx={{
                mb: 2,
                bgcolor: "rgba(30, 91, 92, 0.1)",
                color: "rgba(30, 91, 92, 1)",
                fontWeight: 500,
              }}
            />
            <Typography
              variant="h3"
              component="h2"
              sx={{
                fontWeight: "bold",
                mb: 2,
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              Loan Inquiry Form
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary" }}>
              Submit your loan requirements and we'll notify you when our loan
              services launch.
            </Typography>
          </Box>

          {/* <Card>
            <CardContent sx={{ p: 4 }}>
              <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                Apply for Loan
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
                Fill out this form to express your interest in our upcoming
                loan services.
              </Typography>
              
              <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <TextField
                  name="name"
                  label="Name"
                  value={loanForm.name}
                  onChange={(e) => setLoanForm({ ...loanForm, name: e.target.value })}
                  required
                  fullWidth
                  placeholder="Your full name"
                />
                
                <TextField
                  name="email"
                  label="Email"
                  type="email"
                  value={loanForm.email}
                  onChange={(e) => setLoanForm({ ...loanForm, email: e.target.value })}
                  required
                  fullWidth
                  placeholder="your@email.com"
                />
                
                <TextField
                  name="phone"
                  label="Phone"
                  value={loanForm.phone}
                  onChange={(e) => setLoanForm({ ...loanForm, phone: e.target.value })}
                  required
                  fullWidth
                  placeholder="+91 XXXXX XXXXX"
                />
                
                <FormControl fullWidth required>
                  <InputLabel id="loan-type-label">Loan Type</InputLabel>
                  <Select
                    name="loanType"
                    labelId="loan-type-label"
                    value={loanForm.loanType}
                    label="Loan Type"
                    onChange={(e) => setLoanForm({ ...loanForm, loanType: e.target.value })}
                  >
                    <MenuItem value="Business Loan">Business Loan</MenuItem>
                    <MenuItem value="Home Loan">Home Loan</MenuItem>
                    <MenuItem value="Personal Loan">Personal Loan</MenuItem>
                    <MenuItem value="Loan Against Property">Loan Against Property (LAP)</MenuItem>
                  </Select>
                </FormControl>
                
                <TextField
                  name="amount"
                  label="Loan Amount Required"
                  value={loanForm.amount}
                  onChange={(e) => setLoanForm({ ...loanForm, amount: e.target.value })}
                  required
                  fullWidth
                  placeholder="e.g., ₹5,00,000"
                />
                
                <TextField
                  name="purpose"
                  label="Purpose / Details"
                  value={loanForm.purpose}
                  onChange={(e) => setLoanForm({ ...loanForm, purpose: e.target.value })}
                  fullWidth
                  multiline
                  rows={4}
                  placeholder="Tell us about your loan requirements..."
                />
                
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  fullWidth
                  disabled={submitStatus === "sending"}
                  sx={{
                    bgcolor: 'rgba(30, 91, 92, 1)',
                    '&:hover': { bgcolor: 'rgba(30, 91, 92, 0.8)' },
                    py: 1.5
                  }}
                >
                  {submitStatus === "sending" ? "Submitting..." : "Submit Inquiry"}
                </Button>
                
                {submitStatus === "success" && (
                  <Typography variant="body2" sx={{ color: 'success.main', textAlign: 'center' }}>
                    Inquiry submitted successfully! We'll contact you when loan services are available.
                  </Typography>
                )}
                
                {submitStatus === "error" && (
                  <Typography variant="body2" sx={{ color: 'error.main', textAlign: 'center' }}>
                    Failed to submit inquiry. Please try again or contact us directly.
                  </Typography>
                )}
              </Box>
            </CardContent>
          </Card> */}

          <Card>
            <CardContent sx={{ p: 4 }}>
              <Typography
                variant="h5"
                component="h3"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Apply for Loan
              </Typography>

              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mb: 4 }}
              >
                Fill out this form to express your interest in our upcoming loan
                services.
              </Typography>

              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();

                  // Validation: Require either email or phone
                  if (!loanForm.email && !loanForm.phone) {
                    alert("Please enter either Email or Phone.");
                    setSubmitStatus("error");
                    return;
                  }

                  setSubmitStatus("sending");
                  handleSubmit(e); // call your original submit logic
                }}
                sx={{ display: "flex", flexDirection: "column", gap: 3 }}
              >
                <TextField
                  name="name"
                  label="Name"
                  value={loanForm.name}
                  onChange={(e) =>
                    setLoanForm({ ...loanForm, name: e.target.value })
                  }
                  required
                  fullWidth
                  placeholder="Your full name"
                />

                <TextField
                  name="email"
                  label="Email"
                  type="email"
                  value={loanForm.email}
                  onChange={(e) =>
                    setLoanForm({ ...loanForm, email: e.target.value })
                  }
                  fullWidth
                  placeholder="your@email.com"
                />

                <TextField
                  name="phone"
                  label="Phone"
                  value={loanForm.phone}
                  onChange={(e) =>
                    setLoanForm({ ...loanForm, phone: e.target.value })
                  }
                  fullWidth
                  placeholder="+91 XXXXX XXXXX"
                />

                <FormControl fullWidth required>
                  <InputLabel id="loan-type-label">Loan Type</InputLabel>
                  <Select
                    name="loanType"
                    labelId="loan-type-label"
                    value={loanForm.loanType}
                    label="Loan Type"
                    onChange={(e) =>
                      setLoanForm({ ...loanForm, loanType: e.target.value })
                    }
                  >
                    <MenuItem value="Business Loan">Business Loan</MenuItem>
                    <MenuItem value="Home Loan">Home Loan</MenuItem>
                    <MenuItem value="Personal Loan">Personal Loan</MenuItem>
                    <MenuItem value="Loan Against Property">
                      Loan Against Property (LAP)
                    </MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  name="amount"
                  label="Loan Amount Required"
                  value={loanForm.amount}
                  onChange={(e) =>
                    setLoanForm({ ...loanForm, amount: e.target.value })
                  }
                  required
                  fullWidth
                  placeholder="e.g., ₹5,00,000"
                />

                <TextField
                  name="purpose"
                  label="Purpose / Details"
                  value={loanForm.purpose}
                  onChange={(e) =>
                    setLoanForm({ ...loanForm, purpose: e.target.value })
                  }
                  fullWidth
                  multiline
                  rows={4}
                  placeholder="Tell us about your loan requirements..."
                />

                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  fullWidth
                  disabled={submitStatus === "sending"}
                  sx={{
                    bgcolor: "rgba(30, 91, 92, 1)",
                    "&:hover": { bgcolor: "rgba(30, 91, 92, 0.8)" },
                    py: 1.5,
                  }}
                >
                  {submitStatus === "sending"
                    ? "Submitting..."
                    : "Submit Inquiry"}
                </Button>

                {submitStatus === "success" && (
                  <Typography
                    variant="body2"
                    sx={{ color: "success.main", textAlign: "center" }}
                  >
                    Inquiry submitted successfully! We'll contact you when loan
                    services are available.
                  </Typography>
                )}

                {submitStatus === "error" && (
                  <Typography
                    variant="body2"
                    sx={{ color: "error.main", textAlign: "center" }}
                  >
                    Failed to submit inquiry. Please try again or contact us
                    directly.
                  </Typography>
                )}
              </Box>
            </CardContent>
          </Card>
        </motion.div>
      </Container>
    </Box>
  );
}
